import Vue from 'vue'
import Vuex from 'vuex'
import client from '../services/contentful.service';

Vue.use(Vuex);

const DEFAULT_UJET_COMPANY_KEY = '1520354189505560684908889e8acfb59';
const COBROWSE_KEY = '0Blc4UGxQHHDNA';

function _buildCustomData(companyData) {
  let customData = {
    userAgent: {
      label: 'userAgent',
      value: navigator.userAgent
    }
  };

  for (let key in companyData) {
    let newObject = {};
    newObject[key] = {
      label: key,
      value: companyData[key]
    }
    Object.assign(customData, newObject)
  }
  return customData;
}

export default new Vuex.Store({
  state: {
    loggedIn: false,
    userEmail: '',
    company: null,
    webSDKinitilized: false,
    pages: [],
    ujetInstance: null
  },
  getters: {
    ujetInstance(state) {
      return state.ujetInstance;
    },
    currentPage(state) {
      return state.pages[0];
    },
    companyKey(state) {
      return state.company['crm'] && state.company.crm.fields['companyKey'];
    },
    companySecret(state) {
      return state.company['crm'] && state.company.crm.fields['companySecret'];
    },
    baseUrl(state) {
      const bURL = state.company['crm'] && state.company.crm.fields['baseUrl'] || 'https://main.api.ujetdemo.co';
      return bURL.replace('/api/v2', '');
    },
    customData(state) {
      return _buildCustomData(state.company && state.company.customData || {});
    },
    primaryColor(state) {
      return state.company && state.company.primaryColor || '#3ba5ec';
    },
    companyLogoUrl(state) {
      return state.company && state.company.companyLogo['fields'].file['url'];
    },
    webSDK() {
      return 'https://websdk.ujetdemo.co/v2/loader.js';
    }
  },
  mutations: {
    setUjetInstance(state, ujetInstance) {
      state.ujetInstance = ujetInstance;
    },
    setLogin(state, loggedIn) {
      state.loggedIn = loggedIn;
    },
    setEmail(state, email) {
      state.userEmail = email;
    },
    setCompany(state, company) {
      state.company = company;
    },
    setPages(state) {
      state.pages = state.company ? state.company.pages.map(page => page.fields) : [];
    },
    changePage(state) {
      if (state.pages.length > 1) {
        let pages = state.pages.slice();
        pages.push(pages.shift());
        state.pages = pages;
      }
    },
    changeToPage(state, slug) {
      if (state.pages.length > 1) {
        let pages = state.pages.slice();
        while (slug != pages[0].slug) {
          pages.push(pages.shift());
        }
        state.pages = pages;
      }
    },
    setwebSDKinitilized(state, initialized) {
      state.webSDKinitilized = initialized;
    }
  },
  actions: {
    async getCompany({commit}) {
      const subdomain = window.location.host.split(".")[0];
      const response = await client.getEntries({
        content_type: 'company',
        'fields.subdomain': subdomain
      });
      commit('setCompany', response.items[0] && response.items[0]['fields'])
      commit('setPages');
    },
    initilizeWebSDK({state, getters, commit}) {
      commit('setwebSDKinitilized', true);

      function getAuthToken() {
        let splitEmail = state.userEmail.split('@');
        let user = {
          identifier: state.userEmail,
          name: `${splitEmail[0]} ${splitEmail[1]}`,
          email: state.userEmail
        }
        return fetch('/api/websdk-sign', {
          headers: {'Content-Type': 'application/json'},
          method: "POST",
          body: JSON.stringify({payload: user, companySecret: getters.companySecret})
        }).then(function (resp) {
          return resp.json();
        })
      }

      const UJET = window['UJET']
      const ujetProps = {
        companyId: getters.companyKey || DEFAULT_UJET_COMPANY_KEY,
        logo: getters.companyLogoUrl,
        launcher: {
          style: {
            '--background-color': getters.primaryColor,
          }
        },
        style: {
          '--primary-color': getters.primaryColor,
        },
        customData: getters.customData,
        menuKey: getters.currentPage['directAccessPoint'],
        host: getters.baseUrl,
        cobrowseOptions: {
          license: COBROWSE_KEY,
          trustedOrigins: [window.location.origin, 'https://websdk.ujetdemo.co', 'https://carta.ujet.live']
        }
      };

      if (getters.currentPage['directAccessPoint']) {
        ujetProps.menuKey = getters.currentPage['directAccessPoint'];
      }

      const ujet = new UJET(ujetProps)

      ujet.on('created', function () {
        ujet.authenticate(getAuthToken);
      });

      commit('setUjetInstance', ujet);
    },
    startWebSDKWithMenuKey({ commit }) {
      commit('changePage');
    }
  }
});



// WEBPACK FOOTER //
// ./src/stores/app.store.js